import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import Expenses from "../features/expenses";
import ExpensesHome from "../features/expenses/components/ExpenseHome";
import ExpensesDetail from "../features/expenses/components/ExpensesDetail";
import ExpensesAddCategory from "../features/expenses/components/ExpensesAddCategory";
import ExpensesAddForm from "../features/expenses/components/ExpensesAddForm";
import ExpensesUpdateForm from "../features/expenses/components/ExpensesUpdateForm";
import ExpensesReportHistory from "../features/expenses/components/ExpensesReportHistory";
import ExpensesDetailReport from "../features/expenses/pages/ExpensesDetailReport";
import ExpensesManagerMyTeams from "../features/expenses/pages/ExpensesManagerMyTeams";
import ExpensesDetailReportManager from "../features/expenses/pages/ExpensesManagerMyTeams/ExpensesDetailReportManager";
import ExpensesDetailReportAccountingManager from "../features/expenses/pages/ExpensesManagerMyTeams/ExpensesDetailReportAccountingManager";
import ExpensesReportHistoryTeams from "../features/expenses/pages/ExpensesManagerMyTeams/ExpensesReportHistoryTeams";
import ExpensesAccountingManagerHome from "../features/expenses/pages/ExpensesAccountingManagerHome/ExpensesAccountingManagerHome";

export const expensesRoutes = (
    <Route path={ROUTES.expenses.home} element={<Expenses />} key="expenses">
        <Route index path="" element={<ExpensesHome />} />
        {/* detail expense on creation. */}
        <Route
            path={ROUTES.expenses.detail.route}
            element={<ExpensesDetail />}
        />
        {/* add expense category page */}
        <Route
            path={ROUTES.expenses.add_expense.route}
            element={<ExpensesAddCategory />}
        />
        {/* index route, redirect to the right UPDATE form classic or other */}
        <Route
            path={ROUTES.expenses.update_form.route}
            element={<ExpensesUpdateForm />}
        />
        {/* index route, redirect to the right ADD form classic or other */}
        <Route
            path={ROUTES.expenses.add_form.route}
            element={<ExpensesAddForm />}
        />
        {/* history */}
        <Route
            path={ROUTES.expenses.my_history.route}
            element={<ExpensesReportHistory />}
        />
        {/* detail of any report */}
        <Route
            path={ROUTES.expenses.detail_status_expense.route}
            element={<ExpensesDetailReport />}
        />
        {/* home page of manager */}
        <Route
            path={ROUTES.expenses.manager.home.route}
            element={<ExpensesManagerMyTeams />}
        />
        {/* detail any report manager side */}
        <Route
            path={ROUTES.expenses.manager.detail.route}
            element={<ExpensesDetailReportManager />}
        />
        {/* detail any report accounting manager side */}
        <Route
            path={ROUTES.expenses.accounting_manager.detail.route}
            element={<ExpensesDetailReportAccountingManager />}
        />
        {/* history of manager list by years */}
        <Route
            path={ROUTES.expenses.manager.history.route}
            element={<ExpensesReportHistoryTeams />}
        />
        {/* ACCOUNTING MANAGER */}
        <Route
            path={ROUTES.expenses.accounting_manager.home.route}
            element={<ExpensesAccountingManagerHome />}
        />
    </Route>
);
